/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  invitingUser: UserDtoModelType;
}

/**
 * DriverInviteDtoBase
 * auto generated base class for the model DriverInviteDtoModel.
 */
export const DriverInviteDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('DriverInviteDto')
  .props({
    __typename: types.optional(types.literal("DriverInviteDto"), "DriverInviteDto"),
    id: types.identifier,
    driverId: types.union(types.undefined, types.integer),
    email: types.union(types.undefined, types.string),
    inviteStatusId: types.union(types.undefined, types.integer),
    inviteStatus: types.union(types.undefined, types.null, types.string),
    inviteLink: types.union(types.undefined, types.null, types.string),
    createdBy: types.union(types.undefined, types.string),
    invitingUser: types.union(types.undefined, MSTGQLRef(types.late((): any => UserDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class DriverInviteDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get driverId() { return this.__attr(`driverId`) }
  get email() { return this.__attr(`email`) }
  get inviteStatusId() { return this.__attr(`inviteStatusId`) }
  get inviteStatus() { return this.__attr(`inviteStatus`) }
  get inviteLink() { return this.__attr(`inviteLink`) }
  get createdBy() { return this.__attr(`createdBy`) }
  invitingUser(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`invitingUser`, UserDtoModelSelector, builder) }
}
export function selectFromDriverInviteDto() {
  return new DriverInviteDtoModelSelector()
}

export const driverInviteDtoModelPrimitives = selectFromDriverInviteDto().driverId.email.inviteStatusId.inviteStatus.inviteLink.createdBy
